import { ZOOM_DELTA } from '../../constants';
import { canZoom } from '../../utils';
import { BaseCommand, baseCommand } from '../base';

export const zoomInCommand: BaseCommand = {
  ...baseCommand,

  canUndo() {
    return false;
  },

  canExecute(graph) {
    return canZoom(graph, 'in');
  },

  execute(graph) {
    const ratio = 1 + ZOOM_DELTA;

    const zoom = graph.getZoom() * ratio;
    const maxZoom = graph.get('maxZoom');

    if (zoom > maxZoom) return;

    graph.zoom(ratio);
  },

  shortcuts: [
    ['metaKey', '='],
    ['ctrlKey', '='],
  ],
};

export default zoomInCommand;
